export const actions = {
    SET_IS_LTI: 'SET_IS_LTI',
};

export const setIsLti = payload => ({
    type: actions.SET_IS_LTI,
    payload,
});
